import UserError from './UserError.js'

export class GenericUserError extends UserError {
  #message
  #error
  #status

  static create({message, error, status} = {}) {
    return new GenericUserError({message, error, status})
  }

  constructor(data = {}) {
    super(data)
    this.#message = data.message
    this.#error = data.error
    this.#status = data.status
  }

  get error() {
    return this.#error
  }

  get status() {
    return this.#status
  }

  get message() {
    return this.#message
  }

  toJSON() {
    return {
      message: this.#message,
      error: this.#error,
      status: this.#status
    }
  }
}
